function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-911.83 -16104.536)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-966.17 16045.703)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1885 59.833)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M301.706,665.927h-5.6c-1.8,0-2.515-1.288-2.515-2.995v-1.616c0-3.683,1-5.241,2.1-6.593a5.737,5.737,0,0,1,3.817-2.129,3.064,3.064,0,0,1,2.522,1.423c1.223,1.723,1.207,4.785,1.207,7.79v2.073c0,1.123-.674,2.047-1.523,2.047",
  transform: "translate(-293.588 -649.844)",
  fill: "none",
  stroke: "#0096af",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  y2: 21.667,
  transform: "translate(5.127)",
  fill: "none",
  stroke: "#0096af",
  strokeLinecap: "round",
  strokeWidth: 2,
  strokeDasharray: "3 3.5"
})), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  transform: "translate(1880 59)",
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0,0H24V24H0Z",
  transform: "translate(911.83 16104.703)",
  fill: "none"
}));

var SvgCrossLigthBgd = function SvgCrossLigthBgd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24.167,
    viewBox: "0 0 24 24.167",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrossLigthBgd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross_ligth_bgd.306f5865.svg";
export { ForwardRef as ReactComponent };